import Axios from 'axios';
import config from '@platform/shared/config';

const instance = Axios.create({
     baseURL: config.apiUrlFastify,
    // baseURL: 'http://localhost:3000',

    headers: {
        'Service-ID': config.serviceId,
        'Filestore-Api-Key': config.apiKeyFileStore,
        'Platform-Version': 2,
    },
});

/**
 * Признак для refresh token механизма
 */
// @ts-ignore
instance.__ableToLogin = true;

import('@platform/shared/rpc/node-auth')
    .then(({ registerAxiosForAuthHooks }) => {
        return registerAxiosForAuthHooks(instance);
    })
    .catch(console.error);

export default instance;
